import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { errorCode } from '../personnel/source.js';
import { issuesOf } from './view.js';

/** Alan ayrıntısı (`path:CODE,…`) taşıyan doğrulama hataları. */
const FIELD_ERRORS = new Set([
  'INVALID_PDI_NODE',
  'INVALID_DRYDOCK_PROJECT',
  'INVALID_PDI_RESULT',
  'INVALID_PDI_APPLICABILITY',
  'INVALID_PDI_FINDING',
  'INVALID_DRYDOCK_JOB',
  'INVALID_DRYDOCK_LINK',
  'INVALID_DRYDOCK_DECISION',
  // Faz 4 (ADR 0129 Ek Faz 4)
  'INVALID_DRYDOCK_EVENT',
  'INVALID_DRYDOCK_VERIFICATION',
  'INVALID_PDI_CLOSURE',
]);

/**
 * Dry dock hata metni: bilinen kod (alanlarıyla) ya da genel ileti. İşlev kararlıdır (etki
 * bağımlılığında yeniden yüklemeyi tetiklemez).
 */
export function useDrydockErrorText() {
  const { t } = useTranslation();
  return useCallback(
    (error: unknown) => {
      const code = errorCode(error);
      const detail = (error as { detail?: unknown } | null)?.detail;
      const text = typeof detail === 'string' ? detail : '';
      if (FIELD_ERRORS.has(code)) {
        const fields = issuesOf(text)
          .map((issue) => {
            // Ölçüm satırı: `measurements.2.upper` → "Measurement 3 · Upper"
            const row = /^measurements\.(\d+)\.(.+)$/.exec(issue.path);
            const field = (row ? row[2] : issue.path.replace(/^content\./, '')) ?? '';
            const base = t(`drydock.fields.${field}`, {
              defaultValue: t(`drydock.projectFields.${field}`, {
                defaultValue: t(`drydock.resultFields.${field}`, {
                  defaultValue: t(`drydock.scope.fields.${field}`, {
                    defaultValue: t(`drydock.yard.${field}`, { defaultValue: field }),
                  }),
                }),
              }),
            });
            const label = row
              ? `${t('drydock.resultFields.measurementNo', { no: Number(row[1]) + 1 })} · ${base}`
              : base;
            return `${label} (${t(`drydock.issues.${issue.code}`, { defaultValue: issue.code })})`;
          })
          .join(', ');
        return t(`drydock.errors.${code}`, { fields: fields || text });
      }
      // `detail`: kaydın numarası (ör. incelenmemiş bulgu, PDI_FINDING_UNDECIDED)
      return t(`drydock.errors.${code}`, {
        detail: text,
        defaultValue: t('drydock.errors.generic', { code }),
      });
    },
    [t],
  );
}
